// import RequestOrderPopupArea from "@/pages/comp/book_order/shop/order/acommon/request_order_popup";
import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import FindSimpleTextBookPopup from "@/pages/comp/book_order/textbook/popup/find_simple";
import StuListArea from "./area/stu_list";
import BookListArea from "./area/book_list";
import SumDivArea from "./area/sum_div";

function RequestOrderPopupArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    mcomp_seq: 0,
    stu_seq_arr: [],
    ...props
  };
  let user = useSelector((state: any) => state.user);

  const [stu_info_arr, set_stu_info_arr] = useState<any>([]);
  const [order_book_arr, set_order_book_arr] = useState<any>([]);
  const [is_order_online, set_is_order_online] = useState<boolean>(false);

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "find_textbook",
    has_header: true,
    title: "팝업",
    width: "800px",
    height: "85%",
  });

  useEffect(() => {
    if (strFunc.is_empty(myProps.stu_seq_arr)) {
      alert("학생선택이 필요합니다.");
      myProps.closePopup();
    } else {
      get_stu_info_by_ajax();
    }
  }, []);

  const get_stu_info_by_ajax = () => {
    let tmp_list_opt = {
      s_mcomp_seq: user.mcomp_seq,
      s_seq: myProps.stu_seq_arr,
      // s_addon_textbook_use: "1",
      "is_paging": "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length != 0) {
            set_stu_info_arr(response.data["data"]["info_arr"]);
          } else {
            alert("학생정보가 존재하지 않습니다.");
            myProps.closePopup();
          }
        } else {

        }
      });
  };

  const open_find_textbook_popup = (inData: any) => {
    let opt_obj = {
      ...inData
    };
    if (order_book_arr.length > 0) {
      alert("교재는 한개씩만 주문 할 수 있습니다.");
      return false;
    }
    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": "교재찾기",
      "sort": "find_textbook",
      width: "80%",
      height: "80%",
      has_header: true,
    });
  };

  const callback_open_find_textbook_popup = (inData: any) => {
    let opt_obj = {
      info_arr: [],
      is_order_online: false,
      ...inData
    };
    set_is_order_online(opt_obj.is_order_online);

    if (opt_obj.info_arr.length == 0) {
      alert("선택된 교재가 없습니다.");
      return false;
    }
    let change_order_book_arr = [...order_book_arr];
    if (order_book_arr.length != 0) {
      alert("교재는 한개만 주문할 수 있습니다.");
      return false;
    }
    let pre_book_seq_arr: any = [];
    for (let i = 0; i < order_book_arr.length; i++) {
      pre_book_seq_arr.push(order_book_arr[i].a_seq);
    }
    for (let i = 0; i < opt_obj.info_arr.length; i++) {
      let book_info = opt_obj.info_arr[i];
      if (strFunc.str_in_array(book_info["a_seq"], pre_book_seq_arr) == -1) {
        change_order_book_arr.push(book_info);
      }
    }
    set_order_book_arr(change_order_book_arr);
  };
  
  const go_request_book_order_by_ajax = () => {
    if (order_book_arr.length == 0) {
      alert("선택된 교재가 없습니다.");
      return false;
    }
    let order_book_seq_arr: any = [];
    for (let i = 0; i < order_book_arr.length; i++) {
      order_book_seq_arr.push(order_book_arr[i].a_seq);
    }
    if (stu_info_arr.length == 0) {
      alert("학생정보가 없습니다.");
      return false;
    }
    let select_stu_seq_arr: any = [];
    for (let i = 0; i < stu_info_arr.length; i++) {
      select_stu_seq_arr.push(stu_info_arr[i].a_seq);
    }

    if (!confirm("교재선택을 하시겠습니까?")) {
      return false;
    }

    let form_json_data: any = {
      "mcomp_seq": myProps.mcomp_seq,
      "stu_seq_arr": select_stu_seq_arr,
      "book_seq_arr": order_book_seq_arr,
      "reg_user_seq": user.user_seq,
      "product_type": is_order_online ? "mtextbook_period" : "mtextbook",
      is_order_online: is_order_online ? "1" : "0",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/add_order_by_book',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("교재선택이 완료되었습니다.");
          myProps.refreshData({});
          myProps.closePopup();
        } else {
          alert("교재선택에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  return (
    <div>
      <StuListArea
        stu_info_arr={stu_info_arr}
        set_stu_info_arr={set_stu_info_arr}
      ></StuListArea>
      <div className='text-right'>
        <button className='btn btn-dark'
          onClick={() => { open_find_textbook_popup({}); }}>교재찾기</button>
      </div>
      <div>
        <BookListArea
          order_book_arr={order_book_arr}
          set_order_book_arr={set_order_book_arr}
          is_order_online={is_order_online}
        ></BookListArea>
      </div>
      <div className='mt-2'>
        <SumDivArea
          order_book_arr={order_book_arr}
          stu_info_arr={stu_info_arr}
          is_order_online={is_order_online}
        ></SumDivArea>
      </div>
      <div className='mt-2 my_flex_center'>
        <button className='btn-l btn-sky' onClick={() => { go_request_book_order_by_ajax(); }}>교재선택</button>
        <button className='btn-l btn-dark' onClick={() => { myProps.closePopup(); }}>닫기</button>
      </div>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} has_header={popupData.has_header} >
          {popupData.sort === "find_textbook" &&
            <FindSimpleTextBookPopup
              listOpt={{ s_is_able_order: "1" }}
              refreshData={() => { }}
              xcolumn_unshow_key_arr={["row_view_stock_cnt"]}
              callbackData={callback_open_find_textbook_popup}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></FindSimpleTextBookPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default RequestOrderPopupArea;